import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Navtop.css";

function NavbarTop() {
  return (
    <div className="navtop">
      <Container>
        <Row className="align-items-center">
          <Col md={6} className="navtop-left">
            <span>Mon - Sunday: 24 Hours </span>
          </Col>
          <Col md={6} className="navtop-right text-md-end">
            <span>9404320245 / 9011550390</span>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default NavbarTop;
